import {Button} from '@wandb/weave/components/Button';
import React from 'react';

export const BackButton = ({onClick}: {onClick: () => void}) => {
  return (
    <Button
      data-test="workspace-settings-back-button"
      icon="back"
      variant="ghost"
      onClick={onClick}
    />
  );
};
